import Vue from "vue";
import Router from "vue-router";
// import module from "./module";
import Index from "@views/home/Index";
// import Index2 from "@views/user/promotion/UserCash1";
import GoodsCon from "@views/shop/GoodsCon";
// import Category from "@views/shop/GoodsClass";
// import ShoppingCart from "@views/shop/ShoppingCart";
// import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "通讯录",
        keepAlive: true,
        footer: false,
        backgroundColor: "#02ac54"
      },
      component: Index
    },
	{
	  path: "/detail:id?",
	   // beforeEnter: (to, from, next) => {
	   //      if (to.params.id) {
	   //        to.meta.title = 
	   //      } else {
	   //        to.meta.title = '通讯录详情'
	   //      }
	   //      next()
	   //    },
	  name: "GoodsCon",
	  meta: {
	    title: "通讯录",
	    keepAlive: true
	  },
	  component: GoodsCon
	},
    // ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  // console.log(to.name, form.name);
  // if (auth === true && !$store.state.app.token) {
  //   if (form.name === "Login") return;
  //   return toLogin(true, to.fullPath);
  // }
  document.title = title || process.env.VUE_APP_NAME || "通讯录";
  // //判断是否显示底部导航
  // footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  // //控制悬浮按钮是否显示
  // home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  // $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  // if (auth) {
  //   // $store.dispatch("USERINFO").then(() => {
  //     next();
  //   // });
  // } else
   next();
});

export default router;
